<template>
  <div>
    <div ref="visibleContent" class="relative" @click="!showFull && (showFull = true)">
      <div
        class="relative max-h-full"
        :style="{ maxHeight: showFull ? '100%' : `${maxHeight}px` }"
        :class="{ 'overflow-hidden': !showFull }"
      >
        <slot v-if="showButton && !showFull" name="gradient" />

        <slot />
      </div>
    </div>
    <UiButtonLink
      v-if="showButton"
      class="mt-1.5 w-full text-sm md:w-fit md:text-base"
      @click="showFull = !showFull"
    >
      {{ showFull ? 'Свернуть' : 'Развернуть' }}
      <UiIcon
        name="chevron-down"
        class="inline size-3 transition-transform"
        :class="{ 'rotate-180': showFull }"
      />
    </UiButtonLink>
    <div ref="defaultContent" class="absolute -z-10 opacity-0">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import UiButtonLink from './UiButtonLink.vue'
import UiIcon from './UiIcon.vue'

type PropType = {
  maxHeight?: number
}

const props = withDefaults(defineProps<PropType>(), {
  maxHeight: 448
})

const showFull = ref(false)
const showButton = ref(false)
const defaultContent = ref<HTMLElement | null>(null)
const visibleContent = ref<HTMLElement | null>(null)
const calculateButtonVisibility = () => {
  if (!visibleContent.value || !defaultContent.value) return
  const fullHeight = defaultContent.value.offsetHeight
  const visibleHeight = visibleContent.value.offsetHeight
  showButton.value = fullHeight > props.maxHeight || fullHeight > visibleHeight
}

const hideDefaultContent = () => {
  defaultContent.value?.remove()
}

// при наличии изображений в описании
// нужно для показа кнопки развернуть/свернуть
// иначе кнопка не будет видна
const waitAllImages = async () => {
  const root = defaultContent.value
  if (!root) return

  const promises: Promise<void>[] = []
  root.querySelectorAll('img').forEach((img) => {
    if (img.complete) return
    promises.push(
      new Promise<void>((resolve) => {
        const done = () => resolve()
        img.addEventListener('load', done, { once: true })
        img.addEventListener('error', done, { once: true })
      })
    )
  })

  await Promise.all(promises)
}

onMounted(async () => {
  await waitAllImages()
  calculateButtonVisibility()
  hideDefaultContent()
})
</script>
